/**
 *
 * @file 个人中心/我的消息api
 *
 **/

import AXIOS from '@/utils/$axios';

// 系统信息列表
export const getlist = params =>
    AXIOS.get('/hdc-admin/hdc/user/message/list', { params });

// 未读信息条数
export const getUnread = timeout =>
    AXIOS.get('/hdc-admin/hdc/user/message/unreadAmount', {
        timeout,
    });

// 删除消息
export const deleteMessage = id =>
    AXIOS.post(`/hdc-admin/hdc/user/message/delete/${id}`);

// 标为已读
export const markRead = payload =>
    AXIOS.post(`/hdc-admin/hdc/user/message/update`, payload);

// 要发送消息的用户列表
export const getUsers = payload =>
    AXIOS.post(`/space/enterprise/organization/message/user-list`, payload);

// 发送管家消息
export const sendMessage = payload =>
    AXIOS.post(`/space/enterprise/organization/message/send`, payload);

// 管家消息列表
export const manegerMsgList = payload =>
    AXIOS.post(`/space/enterprise/organization/message/list`, payload);

// 管家消息详情
export const manegerMsgDetail = payload =>
    AXIOS.post(`/space/enterprise/organization/message/detail`, payload);

// 管家消息全部标为已读
export const markAllRead = payload =>
    AXIOS.post(`/space/enterprise/organization/message/all-read`, payload);

// 管家消息删除
export const deleteMsg = payload =>
    AXIOS.post(`/space/enterprise/organization/message/delete`, payload);

// 管家消息撤回
export const repealMsg = payload =>
    AXIOS.post(`/space/enterprise/organization/message/repeal`, payload);
